<template>
  <v-app>
    <div class="calendar-header">
      <v-btn
        fab
        text
        small
        color="grey darken-2"
        @click="prev"
      >
        <i class="fas fa-chevron-left"></i>
      </v-btn>

      <v-toolbar-title v-if="$refs.calendar">
        {{ $refs.calendar.title }}
      </v-toolbar-title>

      <v-btn
        fab
        text
        small
        color="grey darken-2"
        @click="next"
      >
        <i class="fas fa-chevron-right"></i>
      </v-btn>
    </div>

    <transition name="fade">
      <div class="liste-categories" v-if="eventsCategories && Object.keys(eventsCategories).length">
        <ul>
          <li v-for="(categorie, key) in eventsCategories" :key="key">
            <span
              class="couleur"
              :style="{ background: categorie.color }"
            ></span>
            <span>{{categorie.name}}</span>
          </li>
        </ul>
      </div>
    </transition>

    <transition name="fade">
      <div class="eev-sticky-event" v-if="stickyEvent" :style="{'backgroundImage': 'url(' + visuelSticky.url + ')'}">
        <div class="encart-categorie"
          v-if="
            stickyEvent.category_event[0] &&
            eventsCategories[stickyEvent.category_event[0]] &&
            eventsCategories[stickyEvent.category_event[0]].color
          "
          :style="{'background-color': eventsCategories[stickyEvent.category_event[0]].color}"
        >
          {{eventsCategories[stickyEvent.category_event[0]].name}}
        </div>
        <div class="encart-infos">
          <h2>{{stickyEvent.name}}</h2>
          <div class="infos-time">{{displayEventDate(stickyEvent)}}</div>
          <div class="infos-time" v-if="hasEventTime(stickyEvent)">{{displayEventDate(stickyEvent)}}</div>
          <div class="infos-lieu" v-if="stickyEvent.lieu">{{stickyEvent.lieu}}</div>
          <div class="event-link" v-if="stickyEvent.lien">
            <a v-if="lang === 'fr'" :href="stickyEvent.lien" :style="{'background': stickyEvent.color}" target="_blank">Voir l'événement</a>
            <a v-if="lang === 'en'" :href="stickyEvent.lien" :style="{'background': stickyEvent.color}" target="_blank">Learn more about this event</a>
          </div>
        </div>
      </div>
    </transition>

    <v-row class="fill-height zone-calendar">
        <v-col>
          <v-sheet height="727">
            <v-calendar
              ref="calendar"
              v-model="focus"
              :show-month-on-first="false"
              :weekdays="weekdays"
              :locale="lang"
              :events="events"
              :type="type"
              :event-more="false"
              @click:event="showEvent"
            ></v-calendar>

            <v-menu
              v-model="selectedOpen"
              transition="scale-transition"
              :close-on-content-click="false"
              :activator="selectedElement"
              offset-y
            >
              <div class="card-event" :style="{'border-left-color': selectedEvent.color}">
                <h4 :style="{'color': selectedEvent.color}">{{selectedEvent.name}}</h4>
                <div class="cart-event-content">
                  <div>
                    <div class="picto-calendar">
                      <i class="far fa-calendar-alt"></i>
                    </div>
                    <div>
                      {{displayEventDate(selectedEvent)}}
                    </div>
                  </div>
                  <div v-if="hasEventTime(selectedEvent)" class="event-time">
                    <div class="picto-calendar">
                      <i class="far fa-clock"></i>
                    </div>
                    <ul>
                      <li>{{displayEventTime(selectedEvent)}}</li>
                      <li v-if="selectedEvent.horaires">{{selectedEvent.horaires}}</li>
                    </ul>
                  </div>
                  <div v-if="selectedEvent.lieu">
                    <div class="picto-calendar">
                      <i class="fas fa-map-marker-alt"></i>
                    </div>
                    <div>{{selectedEvent.lieu}}</div>
                  </div>
                </div>
                <div class="event-link" v-if="selectedEvent.lien">
                  <a v-if="lang === 'fr'" :href="selectedEvent.lien" :style="{'background': selectedEvent.color}" target="_blank">Voir l'événement</a>
                  <a v-if="lang === 'en'" :href="selectedEvent.lien" :style="{'background': selectedEvent.color}" target="_blank">Learn more about this event</a>
                </div>
              </div>
            </v-menu>
          </v-sheet>
        </v-col>
      </v-row>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex'
import Api from '@/api/axios-api.js'
import moment from 'moment'
export default {
  props: {
    eventsCategories: Object,
    lang: String
  },

  data: () => ({
    focus: '',
    type: 'month',
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    weekdays: [1, 2, 3, 4, 5, 6, 0],
    events: [],
    eventsList: {},
    visuelSticky: window.wpApiSettings.visuelSticky
  }),

  mounted () {
    if (this.lang === 'en') {
      this.weekdays = [0, 1, 2, 3, 4, 5, 6]
    }
    this.fetchData()
  },

  methods: {
    ...mapActions([
      'setLoadingOn',
      'setLoadingOff'
    ]),

    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },

    fetchData () {
      this.setLoadingOn()
      let restURL = window.wpApiSettings.rootFairweb
      let obj = this
      Api.get(restURL + 'events/' + this.lang).then(function (response) {
        let data = response.data
        if (data.liste) {
          obj.eventsList = data.liste
          obj.loadEventsInCalendar()
          obj.setLoadingOff()
        }
      })
    },

    loadEventsInCalendar () {
      Object.keys(this.eventsList).forEach(key => {
        let newEvent = {}
        newEvent.name = this.eventsList[key].name
        if (this.eventsList[key].heure_debut) {
          newEvent.start = new Date(this.eventsList[key].date_debut + ' ' + this.eventsList[key].heure_debut)
        } else {
          newEvent.start = new Date(this.eventsList[key].date_debut)
        }
        if (this.eventsList[key].date_fin) {
          if (this.eventsList[key].heure_fin) {
            newEvent.end = new Date(this.eventsList[key].date_fin + ' ' + this.eventsList[key].heure_fin)
          } else {
            newEvent.end = new Date(this.eventsList[key].date_fin)
          }
        } else {
          if (this.eventsList[key].heure_fin) {
            newEvent.end = new Date(this.eventsList[key].date_debut + ' ' + this.eventsList[key].heure_fin)
          } else {
            newEvent.end = new Date(this.eventsList[key].date_debut)
          }
        }
        newEvent.color = '#999'
        if (this.eventsList[key].color) {
          newEvent.color = this.eventsList[key].color
        }

        newEvent.duree = this.eventsList[key].duree
        newEvent.date_debut = this.eventsList[key].date_debut
        newEvent.date_fin = this.eventsList[key].date_fin
        newEvent.heure_debut = this.eventsList[key].heure_debut
        newEvent.heure_fin = this.eventsList[key].heure_fin
        newEvent.horaires = this.eventsList[key].horaires
        newEvent.lieu = this.eventsList[key].lieu
        newEvent.lien = this.eventsList[key].lien
        newEvent.lien = this.eventsList[key].lien
        newEvent.category_event = this.eventsList[key].category_event

        newEvent.timed = false
        if (this.eventsList[key].heure_debut) {
          newEvent.timed = true
        }
        this.events.push(newEvent)
      })
    },

    openCard () {
      this.selectedOpen = true
    },

    showEvent ({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        let obj = this
        requestAnimationFrame(() => requestAnimationFrame(() => obj.openCard()))
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        requestAnimationFrame(() => requestAnimationFrame(() => open()))
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },

    displayEventDate (eventInfos) {
      let duree = eventInfos.duree
      let displayDate
      let format
      if (this.lang === 'fr') {
        format = 'dddd Do MMMM YYYY'
      }
      if (this.lang === 'en') {
        format = 'dddd MMMM D YYYY'
      }

      if (duree === 'journee') {
        displayDate = moment(eventInfos.date_debut).format(format)
      } else {
        if (this.lang === 'fr') {
          displayDate = 'Du ' + moment(eventInfos.date_debut).format(format) + ' au ' + moment(eventInfos.date_fin).format(format)
        }
        if (this.lang === 'en') {
          displayDate = 'From ' + moment(eventInfos.date_debut).format(format) + ' to ' + moment(eventInfos.date_fin).format(format)
        }
      }
      return displayDate
    },

    hasEventTime (eventInfos) {
      if (eventInfos.heure_debut) {
        return true
      }
      return false
    },

    displayEventTime (eventInfos) {
      let displayTime
      let format
      if (this.lang === 'fr') {
        format = 'H[h]mm'
      }
      if (this.lang === 'en') {
        format = 'h:mm A'
      }
      displayTime = moment('1980-09-18 ' + eventInfos.heure_debut).format(format)
      if (eventInfos.heure_fin) {
        displayTime += ' - ' + moment('1980-09-18 ' + eventInfos.heure_fin).format(format)
      }
      return displayTime
    }

  },
  computed: {
    stickyEvent: function () {
      if (!this.eventsList || !Object.keys(this.eventsList).length) {
        return null
      }
      let arrSticky = null
      Object.keys(this.eventsList).forEach(key => {
        if (this.eventsList[key].sticky_post) {
          arrSticky = this.eventsList[key]
        }
      })
      return arrSticky
    }
  }
}
</script>
<style>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 1s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .v-application{
    font-family: 'NotoSans';
  }

  .theme--light.v-application{
    background:none;
  }

  #main-container{
    overflow: visible;
  }

  .calendar-header{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .calendar-header .v-toolbar__title{
    width: 250px;
    font-size: 2rem;
    text-align: center;
    font-family: 'FjallaOne';
  }

  .calendar-header .v-toolbar__title::first-letter{
    text-transform: uppercase;
  }

  .theme--light.v-calendar-weekly,
  .theme--light.v-sheet,
  .theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday.v-outside{
    background:none;
    border:none;
  }

  .v-calendar-weekly__head, .v-calendar-weekly__head-weekday,
  .theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday.v-outside,
  .theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday.v-past{
    color:#000;
    font-size: 1.1rem;
    font-weight: 600;
    padding: 0.5rem 0;
  }

  .theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday{
    border:none;
  }

  .v-calendar-weekly__week{
    border:none;
  }

  .v-calendar-weekly__head{
    border-bottom:2px solid #e3e3e3;
  }

  .v-calendar-weekly__week{
    border-left:2px solid #e3e3e3;
  }

  .theme--light.v-calendar-weekly .v-calendar-weekly__day{
    border-bottom:2px solid #e3e3e3;
    border-right:2px solid #e3e3e3;
    margin-right: 0;
  }

  .theme--light.v-calendar-weekly .v-calendar-weekly__day,
  .theme--light.v-calendar-weekly .v-calendar-weekly__day.v-outside{
    background:#FFF;
  }

  .v-calendar-weekly__day-label *,
  .v-calendar-weekly__day-label *:hover,
  .v-calendar-weekly__day-label *:focus,
  .v-calendar-weekly__day-label *:active,
  .v-calendar-weekly__day-label{
    cursor: default;
    background:none !important;
    outline:none;
  }

  .v-btn:before{
    display: none !important;
  }

  .v-calendar-weekly__day-label .v-btn .v-btn__content{
    font-size: 0.9rem;
    margin-bottom: 0.25rem;
  }

  .v-calendar-weekly__day.v-outside .v-calendar-weekly__day-label .v-btn .v-btn__content{
    color:#CCC;
  }

  .liste-categories{
    background:#FFF;
    border-radius: 10px;
    margin-bottom: 1.5rem;
    margin-top: 1rem;
  }

  .liste-categories ul{
    display:flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 0.5rem;
  }

  .liste-categories ul li{
    list-style-type: none;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    line-height: 1rem;
    flex:1;
  }

  .liste-categories ul li + li{
    margin-left: 3.5rem;
  }

  .liste-categories ul li span.couleur{
    width: 20px;
    height: 20px;
    min-width: 20px;
    border-radius: 20px;
    display: block;
    margin-right: 0.5rem;
  }

  .v-calendar .v-event{
    border-radius: 0;
  }

  .v-menu__content{
    border-radius: 10px !important;
    transform: translate(-100px, 8px);
    max-width: 350px !important;
    min-width: 0 !important;
  }

  .card-event{
    background:#FFF;
    padding:1rem;
    border-left: 15px solid red;
    min-width: 350px;
    max-width: 350px !important;
  }

  .card-event h4{
    font-family: 'NotoSans';
    font-weight: 600;
    letter-spacing: -0.6px;
    margin-bottom: 1.2rem;
  }

  .card-event .cart-event-content{
    margin-bottom: 1.5rem;
    color:#4A4A4A;
    font-size: 1rem;
    font-weight: 500;
  }

  .card-event .cart-event-content > div{
    display: flex;
    line-height: 1.2rem;
  }

  .card-event .cart-event-content > div + div{
    margin-top: 0.7rem;
  }

  .card-event .cart-event-content .picto-calendar{
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }

  .card-event .cart-event-content .picto-calendar i{
    font-size: 1.5rem;
    width: 40px;
  }

  .card-event .cart-event-content .event-time{
    display: flex;
  }

  .card-event .cart-event-content .event-time ul{
    margin: 0;
    padding: 0;
  }

  .card-event .cart-event-content .event-time ul li{
    list-style-type: none;
  }

  .card-event .event-link a{
    color:#FFF;
    display: inline-block;
    font-family: 'FjallaOne';
    font-size: 1.2rem;
    padding:0.5rem 2rem;
    border-radius: 99em;
  }

  .card-event .event-link a:hover{
    opacity: 0.7;
  }

.eev-sticky-event{
  display: flex;
  margin:1rem 0 2rem 0;
  background-size: cover;
  background-position: center;
  border-radius: 10px;
}

.eev-sticky-event .encart-categorie{
  flex:0.18;
  color:#FFF;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: 'FjallaOne';
  font-size: 1.4rem;
  line-height: 1.5rem;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.eev-sticky-event .encart-infos{
  background:rgba(0,0,0,0.25);
  color:#FFF;
  flex:1;
  padding:1rem 1.7rem;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  font-family: 'NotoSans';
}

.eev-sticky-event .encart-infos h2{
  font-family: 'NotoSans';
  font-weight: 600;
  font-size: 1.9rem;
  margin-bottom: 0.2rem;
}

.eev-sticky-event .encart-infos .infos-time{
  font-size: 1.2rem;
  font-weight: 100;
}

.eev-sticky-event .encart-infos .infos-lieu{
  font-size: 1.1rem;
  font-weight: 100;
  margin-top: 0.25rem;
}

.eev-sticky-event .encart-infos h2::first-letter{
  text-transform: uppercase;
}

.eev-sticky-event .event-link{
  margin-top: 0.9rem;
}

.eev-sticky-event .event-link a{
  display: inline-block;
  padding:0.5rem 2rem;
  color:#FFF;
  font-family: 'FjallaOne';
  font-size: 1.1rem;
  border-radius: 99em;
  border:1px solid #FFF;
  box-shadow: 0px 0px 0px rgba(0,0,0,0.3);
}

.eev-sticky-event .event-link a:hover{
  transform: scale(1.05);
  box-shadow: 4px 4px 4px rgba(0,0,0,0.3);
}

.v-calendar-weekly__day-label{
  margin: 0;
}

.v-calendar-weekly__day-label .v-btn--fab.v-size--small{
  height: auto;
}

@media (min-width: 992px) and (max-width: 1600px) {
  .calendar-header .v-toolbar__title{
    font-size: 1.8rem;
  }

  .liste-categories ul li{
    font-size: 0.9rem;
    line-height: 0.9rem;
  }

  .liste-categories ul li span.couleur{
    width: 15px;
    height: 15px;
    min-width: 15px;
  }

  body.archive.has-calendar h1.entry-title{
    margin-bottom: 1.5rem;
  }

  .liste-categories ul li + li{
    margin-left: 2.5rem;
  }
}

@media (min-width: 992px) and (max-width: 1300px) {
  .liste-categories ul{
    flex-wrap: wrap;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/desktopCalendar.vue